import PropTypes from 'prop-types';
import { Link } from '@gusto/workbench';
import { listing as listingType } from '../proptypes/index';
import Heart from './icons/heart';
import { trackListingReferralClick, trackListingConnectClick } from '../analytics';
import { indexRoute } from '../helpers/index';

const Heading = ({ listing, isAlreadyUser }) => {
  let connectionCountDisplay = null;
  if (listing.number_of_connections) {
    [
      30, 40, 50, 100, 200, 300, 400, 500, 1000, 2500, 5000, 7500, 10000, 25000, 50000, 100000,
      500000, 1000000,
    ].forEach(v => {
      if (listing.number_of_connections >= v) {
        connectionCountDisplay = `${v.toLocaleString()}+`;
      }
    });
  }

  const createAccountInfo = { text: `Get ${listing.name}`, url: listing.website_url };
  const hasDiscount = !!listing.discount_description && !!listing.discount_url;
  if (hasDiscount) {
    createAccountInfo.text = listing.discount_description;
    createAccountInfo.url = listing.discount_url;
  }

  return (
    <div className="heading">
      <div className="container heading">
        <div className="breadcrumb">
          <Link href={indexRoute()} textDecoration="none">
            <i className="arrow-black-left" /> Back to App Directory
          </Link>
        </div>

        <div className="flex flex-center">
          <div>
            <div className="logoContainer">
              <img src={listing.logo_url} alt={`${listing.name} logo`} />
            </div>
          </div>

          <div className="flex flex-grow flex-center">
            <div>
              <h1 className="title">{listing.name}</h1>

              <div className="metadata">
                {listing.categories.map(category => (
                  <div className="categoryPillWrapper" key={category.slug}>
                    <a href={indexRoute(category.slug)} className="categoryPill">
                      {category.name}
                    </a>
                  </div>
                ))}

                {connectionCountDisplay && (
                  <div className="usageInfo">
                    <Heart /> {connectionCountDisplay} companies have connected this integration
                  </div>
                )}
              </div>
            </div>

            <div className="right-content">
              {isAlreadyUser && (
                <Link
                  href="https://app.gusto.com/login"
                  variant="primary"
                  size="large"
                  className="cta"
                  onClick={() => trackListingConnectClick(listing.slug)}
                >
                  Sign in and connect
                </Link>
              )}

              {!isAlreadyUser && (
                <Link
                  href="/invite/company"
                  variant="primary"
                  size="large"
                  className="cta"
                  onClick={() => trackListingConnectClick(listing.slug)}
                >
                  Get started
                </Link>
              )}

              {!!createAccountInfo.url && (
                <div className="referral">
                  <b>Need a {listing.name} account?</b>
                  <br />
                  <Link
                    href={createAccountInfo.url}
                    target="_blank"
                    onClick={() => trackListingReferralClick(listing.slug, hasDiscount)}
                  >
                    {createAccountInfo.text}
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Heading.propTypes = {
  listing: listingType.isRequired,
  isAlreadyUser: PropTypes.bool.isRequired,
};

export default Heading;
